import React from "react";

const MultiSelect = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/2000/xlink"
    >
        <path
            d="m28.185 20.526-.002 5.053h5.04v3.368h-5.04L28.185 34h-3.358l-.002-5.053H19.79V25.58h5.036l.001-5.053h3.358ZM16.432 25.58v3.368H3V25.58h13.432Zm16.79-11.79v3.369H3v-3.369h30.222Zm0-11.789v3.368H3V2h30.222Z"
            className="u_fill"
            fill={fill}
        />
    </svg>
);

export default MultiSelect;


